var _rect, _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoogleIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 44,
    viewBox: "0 0 43 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 43,
    height: 44,
    rx: 21.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.9878 22.2242C32.9878 21.2409 32.9096 20.5234 32.7403 19.7793H21.7291V24.2173H28.1924C28.0621 25.3202 27.3585 26.9811 25.7947 28.0972L25.7728 28.2458L29.2543 30.996L29.4955 31.0205C31.7108 28.9344 32.9878 25.8649 32.9878 22.2242Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7291 33.9178C24.8956 33.9178 27.5539 32.8548 29.4955 31.0211L25.7947 28.0978C24.8044 28.8021 23.4752 29.2937 21.7291 29.2937C18.6277 29.2937 15.9955 27.2076 15.0572 24.3242L14.9196 24.3361L11.2995 27.193L11.2521 27.3272C13.1807 31.2337 17.1421 33.9178 21.7291 33.9178Z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0572 24.3238C14.8096 23.5797 14.6663 22.7824 14.6663 21.9586C14.6663 21.1347 14.8096 20.3375 15.0441 19.5934L15.0376 19.4349L11.3721 16.5322L11.2521 16.5904C10.4573 18.2115 10.0012 20.0319 10.0012 21.9586C10.0012 23.8853 10.4573 25.7056 11.2521 27.3267L15.0572 24.3238Z",
    fill: "#FBBC05"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7291 14.624C23.9313 14.624 25.4168 15.594 26.2638 16.4046L29.5737 13.1093C27.5409 11.1826 24.8956 10 21.7291 10C17.1421 10 13.1807 12.6841 11.2521 16.5906L15.0441 19.5936C15.9955 16.7102 18.6277 14.624 21.7291 14.624Z",
    fill: "#EB4335"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleIcon);
export default __webpack_public_path__ + "static/media/GoogleIcon.db99c1969fd1fcf3663f8c5201941d36.svg";
export { ForwardRef as ReactComponent };